/*
Prevent duplicate initialization
*/
if (!window.themeGiftWithPurchaseInitialized) {

  window.themeGiftWithPurchaseInitialized = true;

  class ThemeGiftWithPurchase {

    constructor() {

      this.enabled = window.themeGwp?.enabled;

      this.variantId = Number(window.themeGwp?.variantId);

      this.shippingMessage =
        window.themeGwp?.shippingMessage ||
        'Add [amount] more for Free AU Shipping!';

      this.shippingUnlockedMessage =
        window.themeGwp?.shippingUnlockedMessage ||
        'You have earned Free Shipping! Add [amount] more for a Free Gift!';

      this.gwpUnlockedMessage =
        window.themeGwp?.gwpUnlockedMessage ||
        'You have earned Free AU Shipping and a Free Gift!';

      /*
      Gift threshold
      */
      this.threshold = Number(window.themeGwp?.threshold);

      /*
      Free shipping threshold
      */
      this.shippingThreshold = Number(window.themeGwp?.shippingThreshold);
      

      this.isProcessing = false;

      this.refreshTimeout = null;

      this.init();
    }

    init() {

      /*
      If GWP disabled,
      remove existing free gift
      */
      if (!this.enabled) {

        this.removeGiftIfExists();

        return;
      }

      /*
      Missing variant safeguard
      */
      if (!this.variantId) {
        console.warn('GWP variant missing');
        return;
      }

      /*
      Redirect gift PDP
      */
      this.redirectGiftProductPage();

      this.bindEvents();

      this.updateEverything();

      /*
      Initial delay because theme loads cart async
      */
      setTimeout(() => {
        this.updateEverything();
      }, 1000);
    }

    /*
    Reusable helper
    */
    isGiftItem(item) {

      return (
        item.variant_id === this.variantId &&
        item.properties &&
        item.properties._free_gift === 'true'
      );
    }

    /*
    Safe money formatter
    */
    formatMoney(cents) {

      return `$${(cents / 100).toFixed(2)}`;
    }

    redirectGiftProductPage() {

      if (!window.themeGwp?.productHandle) return;

      const currentPath = window.location.pathname;

      const giftProductUrl =
        `/products/${window.themeGwp.productHandle}`;

      if (currentPath === giftProductUrl) {

        window.location.replace('/');
      }
    }

    bindEvents() {

      /*
      Theme cart refresh
      */
      document.addEventListener('theme:cart:refresh', () => {

        clearTimeout(this.refreshTimeout);

        this.refreshTimeout = setTimeout(() => {

          this.updateEverything();

        }, 300);

      });

      /*
      Quantity buttons
      */
      document.addEventListener('click', (event) => {

        const target = event.target;

        if (
          target.closest('[data-quantity-plus]') ||
          target.closest('[data-quantity-minus]') ||
          target.closest('[data-item-remove]')
        ) {

          setTimeout(() => {

            this.updateEverything();

          }, 1400);
        }
      });

      /*
      Quantity input changes
      */
      document.addEventListener('change', (event) => {

        if (
          event.target.matches('input[name="updates[]"]')
        ) {

          setTimeout(() => {

            this.updateEverything();

          }, 1400);
        }
      });


      /*
      Cart drawer open
      */
      document.addEventListener('click', (event) => {

        const drawerTrigger = event.target.closest(
          '[data-cart-drawer-toggle]'
        );

        if (!drawerTrigger) return;

        setTimeout(() => {

          this.updateEverything();

        }, 300);

      });


    }

    async getCart() {

      const response = await fetch('/cart.js');

      return await response.json();
    }

    async removeGiftIfExists() {

      try {

        const cart = await this.getCart();

        const updates = {};

        let hasGift = false;

        cart.items.forEach(item => {

          if (this.isGiftItem(item)) {

            updates[item.key] = 0;

            hasGift = true;
          }

        });

        if (!hasGift) return;

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        });

        if (!response.ok) {
          throw new Error('Failed removing gift');
        }

        document.dispatchEvent(
          new CustomEvent('theme:cart:refresh')
        );

      } catch (error) {

        console.error(error);
      }
    }

    async updateEverything() {

      /*
      Prevent duplicate requests
      */
      if (this.isProcessing) return;

      this.isProcessing = true;

      try {

        const cart = await this.getCart();

        /*
        Find gift item
        */
        const giftItem = cart.items.find(item => {
          return this.isGiftItem(item);
        });

        /*
        Force only 1 gift item
        */
        const allGiftItems = cart.items.filter(item => {
          return this.isGiftItem(item);
        });

        /*
        Remove duplicate gifts
        */
        if (allGiftItems.length > 1) {

          const updates = {};

          allGiftItems.forEach((item, index) => {

            if (index > 0) {
              updates[item.key] = 0;
            }

          });

          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates
            })
          });

          if (!response.ok) {
            throw new Error('Failed removing duplicate gifts');
          }
        }

        /*
        Force gift quantity = 1
        */
        const invalidGiftQuantity = cart.items.find(item => {

          return (
            this.isGiftItem(item) &&
            item.quantity > 1
          );

        });

        if (invalidGiftQuantity) {

          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: invalidGiftQuantity.key,
              quantity: 1
            })
          });

          if (!response.ok) {
            throw new Error('Failed correcting gift quantity');
          }
        }

        /*
        Exclude gift product from subtotal
        */
        const subtotalWithoutGift = cart.items.reduce((total, item) => {

          if (this.isGiftItem(item)) {
            return total;
          }

          return total + item.final_line_price;

        }, 0);

        /*
        UPDATE UI
        */
        this.updateUI(subtotalWithoutGift);

        /*
        ADD GIFT
        */
        if (
          subtotalWithoutGift >= this.threshold &&
          !giftItem
        ) {

          await this.addGift();
        }

        /*
        REMOVE GIFT
        */
        if (
          subtotalWithoutGift < this.threshold &&
          giftItem
        ) {

          await this.removeGift();
        }

      } catch (error) {

        console.error(error);

      } finally {

        this.isProcessing = false;
      }
    }

    updateUI(subtotalWithoutGift) {

      const message = document.querySelector(
        '.cart-rewards__message'
      );

      const progressBar = document.querySelector(
        '.cart-rewards__progress-bar'
      );

      const shippingStep = document.querySelector(
        '.cart-rewards__step--shipping'
      );

      const giftStep = document.querySelector(
        '.cart-rewards__step--gift'
      );

      if (!message || !progressBar) return;

      const maxThreshold = Math.max(
        this.shippingThreshold,
        this.threshold
      );

      /*
      Position shipping milestone dynamically
      */
      const shippingPercent =
        (this.shippingThreshold / maxThreshold) * 100;

      shippingStep.style.left =
        `${shippingPercent}%`;

      const progress = Math.min(
        (subtotalWithoutGift / maxThreshold) * 100,
        100
      );

      progressBar.style.width = `${progress}%`;

      shippingStep?.classList.remove('active');
      giftStep?.classList.remove('active');

      /*
      Stage 1
      */
      if (subtotalWithoutGift < this.shippingThreshold) {

        const remaining =
          this.shippingThreshold - subtotalWithoutGift;

        const stage1Message =
          this.shippingMessage.includes('[amount]')
            ? this.shippingMessage.replace(
                '[amount]',
                this.formatMoney(remaining)
              )
            : this.shippingMessage;

        message.innerHTML = stage1Message;

      }

      /*
      Stage 2
      */
      else if (
        subtotalWithoutGift >= this.shippingThreshold &&
        subtotalWithoutGift < this.threshold
      ) {

        shippingStep?.classList.add('active');

        const remaining =
          this.threshold - subtotalWithoutGift;

        const stage2Message =
          this.shippingUnlockedMessage.includes('[amount]')
            ? this.shippingUnlockedMessage.replace(
                '[amount]',
                this.formatMoney(remaining)
              )
            : this.shippingUnlockedMessage;

        message.innerHTML = stage2Message;

      }

      /*
      Stage 3
      */
      else {

        shippingStep?.classList.add('active');
        giftStep?.classList.add('active');

        message.innerHTML =
          this.gwpUnlockedMessage ||
          'You have earned Free AU Shipping and a Free Gift!';
          
      }
    }

    async addGift() {

      try {

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: this.variantId,
                quantity: 1,
                properties: {
                  '_free_gift': 'true'
                }
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Failed adding gift');
        }

        document.dispatchEvent(
          new CustomEvent('theme:cart:refresh')
        );

      } catch (error) {

        console.error(error);
      }
    }

    async removeGift() {

      try {

        const cart = await this.getCart();

        const updates = {};

        cart.items.forEach(item => {

          if (this.isGiftItem(item)) {

            updates[item.key] = 0;
          }

        });

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        });

        if (!response.ok) {
          throw new Error('Failed removing gift');
        }

        document.dispatchEvent(
          new CustomEvent('theme:cart:refresh')
        );

      } catch (error) {

        console.error(error);
      }
    }
  }

  new ThemeGiftWithPurchase();
}